/* eslint-disable react/prop-types */
import { useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../../../../../../../../../contexts/index";
import HeaderContainer from "../headerSection/HeaderSection";
import NextSection from "../nextHeaderSection/NextSection";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../../../../../utils/api/index";
import ExtractRouteQueryParams from "../../../../../../../../../utils/commonFunctions/extractRouteQueryParams";
import useRouteParam from "../../../../../../../../../hooks/useRouteParam";
import PrimaryBeneficary from "../primaryBeneficary/PrimaryBeneficary";
import ContignantBeneficiary from "../contignantBeneficary/ContignantBeneficiary";
import TermsCondition from "../footerTerms/TermsCondition";
import ApproveActiveEnrollment from "../../../../../../../../shared/approveActiveEnrollment/ApproveActiveEnrollment";
import { Grid, Button } from "@material-ui/core";
import SendIcon from "@material-ui/icons/Send";
import { GLIFormActualProps } from "../../../../../../../../../@types/components/gliFormProps.types";

const GLIFormActual = ({
	isPrintable,
	enrollments,
	enrollmentStatus,
	effectiveDate,
	enrollmentDate,
	handleApproveEffectiveDateChange,
	planName
}: GLIFormActualProps) => {
	const { employee, contingent_beneficiery, primary_beneficiery } = enrollments;
	const { theme } = useContext(ThemeContext);
	const navigate = useNavigate();
	const queryEnrollmentId = useRouteParam("eid");
	const routeQueryParam = ExtractRouteQueryParams().join("&");

	const handleRedirectToMemberDetails = useCallback(() => {
		console.log("=========>routeQueryParam==>", routeQueryParam);
		const pathname = `/employer/member?${routeQueryParam}`;
		navigate(pathname);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleSubmitEnrollmentClick = useCallback(async () => {
		if (!queryEnrollmentId) return;
		if (!effectiveDate) {
			alert("Effective date is a required field");
			return;
		}
		try {
			const payload = {
				_id: queryEnrollmentId,
				plan_name: planName,
				effective_date: effectiveDate
			};
			const response = await trackPromise(api.enrollments.AddAutoApproveEnrollment(payload));
			if (response) {
				alert("Auto Approve Enrollment Added Succesfully!");
				handleRedirectToMemberDetails();
			}
		} catch (error) {
			alert("Auto Approve Enrollment Submission unsuccessful!");
			throw error;
		}
	}, [effectiveDate, handleRedirectToMemberDetails, planName, queryEnrollmentId]);

	if (!employee && !contingent_beneficiery && !primary_beneficiery) return <></>;
	// console.log("Enrollments", enrollments);

	return (
		<div className="gli-form-actual-container">
			<HeaderContainer isPrintable={isPrintable} />
			<NextSection employee={employee} isPrintable={isPrintable} />
			<PrimaryBeneficary primaryBeneficery={primary_beneficiery} isPrintable={isPrintable} />
			<ContignantBeneficiary contingentBeneficiery={contingent_beneficiery} isPrintable={isPrintable} />
			<TermsCondition employee={employee} enrollmentDate={enrollmentDate} isPrintable={isPrintable} />

			<div className="approve-active-enrollment" style={{ marginTop: "2rem" }}>
				<ApproveActiveEnrollment
					enrollmentDate={enrollmentDate}
					enrollmentStatus={enrollmentStatus}
					effectiveDate={effectiveDate}
					handleApproveEffectiveDateChange={handleApproveEffectiveDateChange}
				/>
			</div>
			<div className="theme-plan-section-margin" />
			<Grid container>
				<Grid item xl={4} lg={4} md={4} sm={12} xs={12}></Grid>
				<Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
					<Button
						className="button-green"
						onClick={handleSubmitEnrollmentClick}
						variant="contained"
						style={{
							pointerEvents: "unset"
						}}
					>
						<span className="button-label-with-icon">Submit</span>
						<span>
							<SendIcon className="button-icon" />
						</span>
					</Button>
				</Grid>
				<Grid item xl={4} lg={4} md={4} sm={12} xs={12}></Grid>
			</Grid>
		</div>
	);
};

export default GLIFormActual;
